module.exports = __webpack_public_path__ + "static/img/login_background.fdd8f7ab.svg";